import React from "react";
import moment from "moment";
import '../ovulation-calculator-css/ovulation-result-calendar.css'
// import Symptoms from './Symptoms';

export default class Calendar extends React.Component {
  weekdayshort = moment.weekdaysShort();

  state = {
    showCalendarTable: true,
    showMonthTable: false,
    dateObject: moment(this.props.selectedDate),
    allmonths: moment.months(),
    showYearNav: false,
    selectedDay: null,
    showSymptoms: false,
    selectedMonth: this.props.currentMonth,
    selectedYear: this.props.currentYear
  };

  componentDidUpdate(nextProps) {
    if (this.props.selectedDate !== nextProps.selectedDate ||
      this.props.currentMonth !== nextProps.currentMonth ||
      this.props.currentYear !== nextProps.currentYear) {
      this.setState({
        dateObject: moment(this.props.selectedDate),
        selectedMonth: this.props.currentMonth,
        selectedYear: this.props.currentYear
      })
    }
  }
  daysInMonth = () => {
    return this.state.dateObject.daysInMonth();
  };
  year = () => {
    return this.state.dateObject.format("Y");
  };
  currentDay = () => {
    return this.state.dateObject.format("D");
  };
  firstDayOfMonth = () => {
    let dateObject = this.state.dateObject;
    let firstDay = moment(dateObject)
      .startOf("month")
      .format("d"); // Day of week 0...1..5...6
    return firstDay;
  };
  month = () => {
    return this.state.dateObject.format("MMMM");
  };

  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format("YYYY"));
      currentDate = moment(currentDate).add(1, "year");
    }
    return dateArray;
  }
  onDayClick = (e, d, m, y) => {
    this.setState(
      {
        selectedDay: d,
        showSymptoms: true
      },
      () => {
        console.log("SELECTED DAY: ", this.state.selectedDay);
        // this.props.getSymtopms(d, this.props.dateModel, m, y)
        // console.log(this.props.dateModel)
      }
    );

  };

  render() {
    let weekdayshortname = this.weekdayshort.map(day => {
      return <th key={day}>{day.slice(0, 1).toUpperCase()}</th>;
    });
    let blanks = [];
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(<td className="calendar-day empty" key={`id-${i}`}>{""}</td>);
    }
    let daysInMonth = [];
    let currentDayClass = {};
    let currentDate = new Date();
    for (let d = 1; d <= this.daysInMonth(); d++) {
      let appliedclass = {
        'backgroundColor': '',
        'fontFamily': ''
      };
      if (!this.props.isDefault) {
        let OvulationItem = this.props.dateModel.filter((item) => {
          if (item.dayDescription === 'Ovulation Day' && item.day == d) {
            return item
          }
        });
        const result = this.props.dateModel.filter((item) => {
          if (item.day == d) {
            return item
          }
        });

        if (result.length > 0) {
          if (OvulationItem.length > 0 && result[0].day == OvulationItem[0].day) {
            appliedclass = {
              'backgroundColor': OvulationItem[0].colorCode,
              'fontFamily': OvulationItem[0].fontFamily,
              'cursor': this.props.selectedTrackKey ? 'pointer' : 'default'
            }
          }
          else {
            appliedclass = {
              'backgroundColor': result[0].colorCode,
              'fontFamily': result[0].fontFamily,
              'cursor': this.props.selectedTrackKey ? 'pointer' : 'default'
            }
          }

          // if (currentDate.getFullYear() === this.props.currentYear && currentDate.getMonth() === this.props.currentMonth && result[0].day === currentDate.getDate()) {
          //   console.log()
          //   appliedclass = {
          //     'color': '#DA291C !important',
          //     'border': '2px solid',
          //     'border-radius': '50%'
          //   }
          // }

          // if (result[0].dayDescription == 'Current Day') {
          //   appliedclass = {
          //     'color' : '#DA291C !important',
          //     'border': '2px solid',
          //     'border-radius': '50%'
          //   }
          // }

        }
        if (currentDate.getFullYear() === this.props.currentYear && currentDate.getMonth() === this.props.currentMonth && d === currentDate.getDate()) {
          // console.log(d)
          currentDayClass = {
            'color': '#DA291C !important',
            // 'border': '2px solid',
            // 'border-radius': '50%'
          }
        } else {
          currentDayClass = {}
        }
        // if(result.length > 0 && result[0].day === d){
        //   currentDayClass = {}
        // }
      }
      daysInMonth.push(
        <td key={d} className={currentDayClass.color ? 'calendar-day current-day-class' : `calendar-day`} style={appliedclass} onClick={e => {
          this.onDayClick(e, d, this.state.selectedMonth, this.state.selectedYear);
        }}>
          <span

          >
            {this.props.isDefault ? '' : d}
          </span>
        </td>
      );
    }
    var totalSlots = [...blanks, ...daysInMonth];
    let rows = [];
    let cells = [];

    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
      if (i === totalSlots.length - 1) {
        rows.push(cells);
      }
    });

    let daysinmonth = rows.map((d, i) => {
      return <tr key={`id-${i}`}>{d}</tr>;
    });

    return (
      <>
        <div className="tail-datetime-calendar" style={{ position: 'relative' }}>
          <div className="calendar-navi">
            {!this.state.showMonthTable && !this.state.showYearEditor && (
              <span className="calendar-label">
                {this.month()} {this.year()}
              </span>
            )}
          </div>
          {this.state.showCalendarTable && (
            <div className="calendar-date">
              <table className="calendar-day">
                <thead>
                  <tr>{weekdayshortname}</tr>
                </thead>
                <tbody>{daysinmonth}</tbody>
              </table>
            </div>
          )}
        </div>
        {/* {this.state.showSymptoms && <Symptoms selectedDay={this.state.selectedDay} getSymtopms={this.getSymtopms}/>} */}
      </>
    );
  }
}